import { ReactNode } from 'react';
import { IoInformationCircleOutline } from 'react-icons/io5';

interface AnalyticsCardProps {
  label: string;
  value: string | number | ReactNode;
  valueClassName?: string;
  tooltip?: string;
}

export function AnalyticsCard({ label, value, valueClassName, tooltip }: AnalyticsCardProps) {
  return (
    <div className="bg-primary-soft rounded-lg border border-gray-200 p-4">
      <div className="flex items-center gap-2 mb-1">
        <p className="text-sm text-gray-600 font-semibold">{label}</p>
        {tooltip && (
          <div className="group relative inline-flex">
            <IoInformationCircleOutline className="size-4 text-gray-400 hover:text-gray-600 cursor-help" />
            {/* Tooltip with centered positioning to avoid viewport overflow */}
            <div className="absolute left-1/2 -translate-x-1/2 bottom-full mb-2 hidden group-hover:block z-50 w-56 p-3 bg-gray-900 text-white text-xs rounded-lg shadow-lg whitespace-normal leading-relaxed">
              {tooltip}
              <div className="absolute left-1/2 -translate-x-1/2 top-full w-0 h-0 border-l-[6px] border-l-transparent border-r-[6px] border-r-transparent border-t-[6px] border-t-gray-900" />
            </div>
          </div>
        )}
      </div>
      <p className={`text-2xl font-bold ${valueClassName || 'text-brand-dark'}`}>
        {value}
      </p>
    </div>
  );
}
